export  const encodeData = (data) => {
    data = JSON.stringify(data);
    let encodedData = encodeURIComponent(data);
    return encodedData;
  };